import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth';
import { installErrorReporting } from './log';
import './styles.css';

// Before anything else renders, so a failure during the first paint is still
// reported rather than being the one class of bug nobody can see.
installErrorReporting();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // The portal is a record-keeping view, not a live dashboard; refetching
      // on every window focus would be noise. Mutations invalidate explicitly.
      refetchOnWindowFocus: false,
      staleTime: 15_000,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
